import type { PressLogo } from '../types/landing'

export const pressLogos: PressLogo[] = [
  { name: 'People', style: 'people' },
  { name: 'Bravo', style: 'script' },
  { name: 'ET', style: 'et' },
  { name: 'Martha Stewart', style: 'box' },
  { name: 'Brides', style: 'caps' },
  { name: 'weddings', style: 'lower' },
]
